<template>
  <div :style="maxHeight" style="overflow-y: auto;overflow-x: hidden">
    <div style="margin-left: 40px">
      <el-button v-if="this.parentData" type="success" :loading="loading" @click="deleteChartData">{{"数据修复"}}</el-button>
      <el-button type="primary">{{"物件选择"}}</el-button>
      <el-select v-model="wuJianId" @change="renderAllEcharts" clearable placeholder="物件名称" style="width: 200px;">
        <el-option
            v-for="item in wuJianNames"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-button v-if="this.parentData" style="margin-left: 10px" type="success" @click="recordRepair">{{"组立检查详情修复"}}</el-button>
    </div>

    <el-row style="height: 45%;">
      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          <span>{{'组立不良项目数量占比'}}</span>
          <div class="space-between">
            <el-date-picker v-model="pieDate.year" @change="getPieChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
            <el-date-picker v-model="pieDate.month" @change="getPieChart" format="MM 月" value-format="MM" clearable type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
            <el-date-picker v-model="pieDate.day" @change="getPieChart" format="DD 日" value-format="DD" clearable type="day" placeholder="日" style="width: 70px;" size="small"/>
          </div>
        </div>
        <div v-loading="pieChartLoading" element-loading-text="数据加载中" style="width: 100%;height: 90%" id="pieZuLi"/>
      </el-col>
      <el-col :span="12" style="border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          {{'单元不良信息'}}
          <div class="space-between">
            <el-date-picker v-model="zLUnitBadData.year" @change="getZLUnitBadData" format="YYYY 年" value-format="YYYY" :clearable="false" type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
            <el-date-picker v-model="zLUnitBadData.month" @change="getZLUnitBadData" format="MM 月" value-format="MM" :clearable="false" type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
            <!--          <el-date-picker v-model="pieDate.day" @change="getZLUnitBadData" format="DD 日" value-format="DD" clearable type="day" placeholder="日" style="width: 70px;" size="small"/>-->
          </div>
        </div>
        <!--          <dv-scroll-board :config="zlBadInfo" style="width:90%;height:85%" />-->
        <el-table v-loading="tableBadDataLoading" :data="tableBadData" style="width: 100%;height: 200%" :stripe="true">
          <el-table-column prop="wujianName" label="物件略称"/>
          <el-table-column prop="unit_no" label="单元号"/>
          <el-table-column prop="check_time" label="检查时间" width="155" />
          <el-table-column prop="ng_name" label="不良类别" width="120" align="center" />
          <el-table-column prop="ng_grade" label="等级" align="center" width="60" />
          <el-table-column prop="responsible_department" label="部门" align="center" width="100"/>
        </el-table>
      </el-col>
    </el-row>

    <el-row style="height: 49%;">
      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          <span>{{'组立不良类别统计'}}</span>
          <div class="space-between">
            <el-date-picker v-model="badType.year" @change="getTypeChart" format="YYYY 年" value-format="YYYY" clearable type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
            <el-date-picker v-model="badType.month" @change="getTypeChart" format="MM 月" value-format="MM" clearable type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
            <el-select v-model="badType.responseDepart" @change="getTypeChart" clearable placeholder="责任部门" size="small" style="width: 80px;margin-right: 10px">
              <el-option
                  v-for="item in responseDeparts"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="badType.ng_grade" @change="getTypeChart" clearable placeholder="不良等级" size="small" style="width: 80px">
              <el-option
                  v-for="item in ng_grades"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div v-loading="typeBadLoading" element-loading-text="数据加载中" style="width: 100%;height: 88%" id="typeBadZuLi"/>
      </el-col>
    </el-row>

    <el-row style="height: 49%;">
      <el-col :span="12" style="border-right: 8px solid whitesmoke;border-bottom: 8px solid whitesmoke;height: 100%">
        <div class="title">
          <span>{{'组立日不良堆积'}}</span>
          <div class="space-between">
            <el-date-picker v-model="dayType.year" @change="getDayBadChart" format="YYYY 年" :clearable="false" value-format="YYYY" type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
            <el-date-picker v-model="dayType.month" @change="getDayBadChart" format="MM 月" :clearable="false" value-format="MM" type="month" placeholder="月" style="width: 70px; margin-right: 10px" size="small"/>
          </div>
        </div>
        <div v-loading="dayBadLoading" element-loading-text="数据加载中" style="width: 100%;height: 88%" id="dayBadZuLi"/>
      </el-col>
    </el-row>

    <KfDialog v-model="dialogVisible" :item="dialogItem">

      <template #footer>
        <div style="display: flex;flex-direction: column;align-items: center;justify-content: space-around;">
          <div style="width:100%; display: flex;flex-direction: row;align-items: center;justify-content: space-around;">
            <span style="font-size: 24px;">{{this.chartData.name}}</span>
            <el-input-number v-model="this.chartData.value"/>
          </div>
          <el-button style="margin-top: 20px" type="primary" @click="editChartData">{{"保存"}}</el-button>
        </div>
      </template>
    </KfDialog>

  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "ZuLiZhiJianPage",
  props: ['parentData'],
  data(){
    return{
      maxHeight:'',
      dialogVisible:false,
      loading:false,
      dialogItem:{
        title:'',
        width:'30%'
      },
      chartData:{},
      pieDate:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:this.$common.getDateLabel(new Date().getUTCMonth() + 1),
        day:''
      },
      badType:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:this.$common.getDateLabel(new Date().getUTCMonth() + 1),
        ng_grade: '',
        responseDepart:''
      },
      dayType:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:this.$common.getDateLabel(new Date().getUTCMonth() + 1)
      },
      wuJianId:'',
      wuJianNames:[],
      wuJianTarget:0,
      ng_grades:[],
      responseDeparts:[],
      /*不良项目数量占比*/
      optionPie:{
        type:'pie_chart',
        title: {
          text: '总数量',
          top: '37%',
          left: '49%',
          textAlign: 'center',
          textStyle: {
            color: 'black',
            fontSize: '20px',
            lineHeight: 30
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          type: 'scroll',
          orient: 'horizontal',
          data: [
            { value: 1048, name: '二次胶不良' },
            { value: 735, name: '内脏' },
            { value: 580, name: '开裂' },
            { value: 484, name: '变形' },
            { value: 84, name: '擦伤,划伤' },
            { value: 44, name: '膜不良' },
            { value: 84, name: '爆边,爆角' },
            { value: 84, name: 'PVB不良' },
            { value: 44, name: '结石' },
            { value: 44, name: '叠差' },
            { value: 44, name: '表面凹坑' },
            { value: 44, name: '无应力' },
            { value: 44, name: '氩气不足' },
            { value: 300, name: '实物与标签不符' }
          ],
        },
        series: [
          {
            name: '不良项目',
            type: 'pie',
            radius: ['40%', '65%'],
            center: ['50%', '50%'],
            label:{
              show: true,
              formatter: '{b},{d}%'
            },
            data: [
              { value: 44, name: '无应力' },
              { value: 84, name: '擦伤,划伤' },
              { value: 1048, name: '二次胶不良' },
              { value: 44, name: '膜不良' },
              { value: 735, name: '内脏' },
              { value: 44, name: '氩气不足' },
              { value: 84, name: 'PVB不良' },
              { value: 580, name: '开裂' },
              { value: 44, name: '叠差' },
              { value: 484, name: '变形' },
              { value: 44, name: '结石' },
              { value: 84, name: '爆边,爆角' },
              { value: 300, name: '实物与标签不符' },
              { value: 44, name: '表面凹坑' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      pieChartLoading:false,
      /*不良类别统计*/
      optionTypeBad: {
        type:'type_chart',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            nameTextStyle: {
              fontSize: 4
            },
            axisLabel: {
              fontSize: 9,
              formatter: function (value) {
                let str = value.split("");
                  return str.join("\n");
              },
            },
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良数量',
            min: 0,
            max: 10,
            interval: 2,
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '不良数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            barWidth:10,
            data: []
          },

        ]
      },
      optionDrum: {
        type:'drum_chart',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (params) {
            let result = '';
            params.forEach(function (item) {
              if (item.value !== 0) {  // 过滤掉值为 0 的数据
                result += item.marker + ' ' + item.seriesName + ' : ' + '<strong>' + item.value + '</strong><br>';
              }
            });
            return result;
          }
        },
        legend: {
          type: 'scroll',
          orient: 'horizontal',
        },
        grid: {
          left: '8%',
          right: '8%',
          bottom: '8%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '不良数量',
            // max: function (value) {
            //   return value.max + 20;
            // }
          }
        ],
        series: []
      },
      dayBadLoading:false,
      typeBadLoading:false,
      tableBadData:[],
      tableBadDataLoading:false,
      zLUnitBadData:{
        year:this.$common.getCurrentYearByMonth().toString(),
        month:this.$common.getDateLabel(new Date().getUTCMonth() + 1)
       /* day:''*/
      },
    }
  },

  methods:{
    getMaxHeight() {
      let pageHeight = document.body.scrollHeight - 160;
      this.maxHeight = "height: "+pageHeight+"px;";
    },
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },

    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
        let _this = this
      /*  let time
        //chart绑定滚动事件
        chart.on('dataZoom',function (params) {
          //滚动条事件添加防抖
          clearTimeout(time)
          time = setTimeout(()=>{
            _this.getWuJianChartData(params)
          },1000)
        })*/

        if (id === 'pieZuLi') {
          chart.on('legendselectchanged', function (params) {
            let array = []
            option.series[0].data.map((item)=>{
              if (params.selected[item.name]){
                array.push(item)
              }
            })
            option.legend.selected = params.selected
            option.title.text = "合计\n" + _this.$common.getPieSum(array)
            // chart.clear()
            chart.setOption(option)
          })
        }

        if (this.parentData) {
          chart.on('click', function (params) {
            _this.dialogVisible = true
            _this.dialogItem.title = params.seriesName
            _this.chartData.seriesName = params.seriesName
            _this.chartData.value = params.value
            _this.chartData.name = params.name
            _this.chartData.dataIndex = params.dataIndex
            _this.chartData.seriesIndex = params.seriesIndex
            _this.chartData.chartType = option.type
          })
        }else{
          chart.on('click', (params) => {
            let query = {}
            query.wujian_id = _this.wuJianId
            query.name = params.name
            query.date = _this.pieDate
            query.seriesName = params.seriesName
            if ("pie_chart" === option.type){
              _this.openPage(query)
            }
          })
        }
      }
    },

    async openPage(data){
      let windowObj = {}
      windowObj.icon = "system/view";
      windowObj.component = "frame/FrameQuery";
      windowObj.componentParam = "bus_zuli_check_item_record_ng_query";
      windowObj.name = "不良项目详情";
      windowObj.parentData = data;
      windowObj.height = 720 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1400 || this.$store.getters['core/getGlobalWindowWidth']

      this.$store.dispatch('core/openWindow', windowObj)
    },

    renderAllEcharts(){
      this.getPieChart()
      this.getTypeChart()
      this.getZLUnitBadData()
      this.getDayBadChart()
    },

    async deleteChartData(){
      this.loading = true
      let {data: res} = await this.$axios.post('bus/homePage/deleteChartData',"bus_zulizhijian_page");
      if (res.code !== 0) {
        this.$message.error('刷新失败！请重试')
      }else {
        this.$message.success('刷新成功！')
        this.renderAllEcharts()
      }
      this.loading = false
    },

    async editChartData(){
      switch (this.chartData.chartType){
        case "wujian_chart":
          this.wujianQuery.wujian_id = this.wuJianId
          this.chartData.query = this.wujianQuery
          break
        case "pie_chart":
          this.pieDate.wujian_id = this.wuJianId
          this.chartData.query = this.pieDate
          break
        case "drum_chart":
          this.drumDate.wujian_id = this.wuJianId
          this.chartData.query = this.drumDate
          break
        case "type_chart":
          this.badType.wujian_id = this.wuJianId
          this.badType.field = this.badType.ng_grade
          this.badType.field1 = this.badType.responseDepart
          this.chartData.query = this.badType
          break
        case "day_chart":
          this.dayBad.wujian_id = this.wuJianId
          this.chartData.query = this.dayBad
          break
      }
      this.chartData.model = "bus_zulizhijian_page"
      this.chartData.dataKey = this.$common.getChartDataKey(this.chartData)
      let {data: res} = await this.$axios.post('bus/homePage/editChartData',this.chartData);
      if (res.code !== 0) {
        this.$message.error('修改失败！请重试')
      }else {
        this.$message.success('修改成功！')
        this.dialogVisible = false
      }
      switch (this.chartData.chartType){
        case "wujian_chart":
          await this.getWuJianChart()
          break
        case "pie_chart":
          await this.getPieChart()
          break
        case "drum_chart":
          await this.getDrumChart()
          break
        case "type_chart":
          await this.getTypeChart()
          break
        case "day_chart":
          await this.getDayChart()
          break
      }

    },

    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('bus/datasource/getWuJianInFo');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },

    async getNg_grade() {
      let {data: res} = await this.$axios.post('bus/datasource/getDictList','ng_grade');
      if (res.code !== 0) {
        this.$message.error('获取不良等级失败')
        return;
      }
      this.ng_grades = res.data;
    },

    async getResponseDeparts() {
      let {data: res} = await this.$axios.post('bus/datasource/getAllData','bus_zuli_check_item_record.responsible_department');
      if (res.code !== 0) {
        this.$message.error('获取责任部门失败')
        return;
      }
      this.responseDeparts = res.data;
    },

    /*async getWuJianChartData(params) {
      let range
      if (params.batch){
        range = params.batch[0]
      }else {
        range = params
      }
      this.wuJianChartLoading = true
      let query = {
        wuJianId:this.wuJianId,
        start:Math.floor(this.optionWuJian.xAxis[0].data.length * range.start/100),
        end:Math.ceil(this.optionWuJian.xAxis[0].data.length * range.end/100),
      }
      let {data: res} = await this.$axios.post('bus/zuLiZhiJian/wuJianChart',JSON.stringify(query));
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.wuJianChartLoading = false
      }else {
        if (res.data.XMonth) {
          this.optionWuJian.xAxis[0].data = res.data.XMonth
          this.optionWuJian.series[0].data = res.data.badNum
          /!*this.optionWuJian.series[1].data = res.data.badNumTwo*!/
          for (let i = 0; i < this.optionWuJian.xAxis[0].data.length; i++) {
            this.optionWuJian.series[1].data.push(this.wuJianTarget)
          }
          this.optionWuJian.series[2].data = res.data.badPercent
          let a = this.$common.getDivisor(Math.max(...res.data.badNum))
          this.optionWuJian.yAxis[0].max = Math.ceil(Math.max(...res.data.badNum)/a)*a
          this.optionWuJian.yAxis[0].interval = Math.round(this.optionWuJian.yAxis[0].max/5*100)/100
          /!*this.optionWuJian.yAxis[1].max = Math.max(...res.data.badPercent) > this.wuJianTarget ? Math.max(...res.data.badPercent) : this.wuJianTarget
          this.optionWuJian.yAxis[1].interval = Math.round(this.optionWuJian.yAxis[1].max/5*100)/100*!/
          this.optionWuJian.dataZoom[0].start = range.start
          this.optionWuJian.dataZoom[0].end = range.end
        }
        this.renderEcharts('wuJianZuLi',this.optionWuJian)
      }
      this.wuJianChartLoading = false
    },*/

    async getPieChart() {
      if (!this.pieDate.year){
        this.pieDate.year =  this.$common.getCurrentYearByMonth().toString()
      }
      this.pieDate.wujian_id = this.wuJianId
      this.pieChartLoading = true
      let {data: res} = await this.$axios.post('bus/zuLiZhiJian/pieChart',this.pieDate);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      this.optionPie.legend.data = res.data
      this.optionPie.series[0].data = res.data
      this.optionPie.title.text = "合计\n" + this.$common.getPieSum(this.optionPie.series[0].data)
      this.renderEcharts('pieZuLi',this.optionPie)

      this.pieChartLoading = false
    },

    async getTypeChart() {
      if (!this.badType.year){
        this.badType.year =  this.$common.getCurrentYearByMonth().toString()
      }
      this.typeBadLoading = true
     this.badType.wujian_id = this.wuJianId
      let {data: res} = await this.$axios.post('bus/zuLiZhiJian/typeChart',this.badType);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      let i,j,num,xName
      for (i = 1; i < res.data.xData.length; i++) {

        num = res.data.xData[i]
        xName = res.data.xAxix[i]
        for (j = i - 1; j >= 0; j--){

          if (num > res.data.xData[j]){
            res.data.xData[j + 1] = res.data.xData[j]
            res.data.xAxix[j + 1] = res.data.xAxix[j]
          }else {
            break
          }
        }
        res.data.xData[j + 1] = num
        res.data.xAxix[j + 1] = xName
      }
      this.optionTypeBad.xAxis[0].data = res.data.xAxix
      this.optionTypeBad.series[0].data = res.data.xData
      let a = this.$common.getDivisor(Math.max(...res.data.xData))
      this.optionTypeBad.yAxis[0].max = Math.ceil(Math.max(...res.data.xData)/a)*a
      this.optionTypeBad.yAxis[0].interval = Math.round(this.optionTypeBad.yAxis[0].max/5*100)/100
      this.renderEcharts('typeBadZuLi',this.optionTypeBad)

      this.typeBadLoading = false
    },

    async getDayBadChart() {
      if (!this.dayType.year){
        this.dayType.year =  this.$common.getCurrentYearByMonth().toString()
      }
      this.drumChartLoading = true
      this.dayType.wujian_id = this.wuJianId
      let {data: res} = await this.$axios.post('bus/zuLiZhiJian/getDayBadChart',this.dayType);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }
      if (res.data) {
        console.log(res.data)
        this.optionDrum.xAxis[0].data = res.data.dayList
        this.optionDrum.series = res.data.series
        this.optionDrum.yAxis[0].name = this.yAxisName
        this.renderEcharts('dayBadZuLi', this.optionDrum)
      }

      this.drumChartLoading = false
    },

    async getZLUnitBadData() {
      this.tableBadDataLoading = true
      let query = {
        wujian_id:this.wuJianId,
        date1:this.zLUnitBadData.year + '-' + this.zLUnitBadData.month + '-1 08:00',
        date2:this.zLUnitBadData.year + '-' + (Number(this.zLUnitBadData.month) + 1) + '-1 08:00',
      }
      if (Number(this.zLUnitBadData.month) === 12){
        query.date1 = this.zLUnitBadData.year + '-' + this.zLUnitBadData.month + '-1 08:00'
        query.date2 = (Number(this.zLUnitBadData.year) + 1) + '-1-1 08:00'
      }
      let {data: res} = await this.$axios.post('bus/zuLiZhiJian/getZLUnitBadData',query);
      console.log(res)
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.tableBadData = res.data
      }

      this.tableBadDataLoading = false
    },

    async recordRepair(){
      let {data: res} = await this.$axios.get('busZuLiService.recordRepair');
      if (res.code !== 0) {
        this.$message.error('修复失败！请重试')
      }else {
        this.$message.success('修复成功！')
      }
    },

  },

  created() {
    this.getMaxHeight()
    this.getWuJianInFo()
    this.getNg_grade()
    this.getResponseDeparts()
    this.getZLUnitBadData()
  },

  mounted() {
    this.renderAllEcharts()
  }

}
</script>

<style scoped>
.pageContainer{
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
.asideContainer{
  width: 50%;
  height: 880px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.title{
  border-left: 3px solid steelblue;
  height: 25px;
  width: 80%;
  font-size: 16px;
  margin-left: 40px;
}


</style>